export default __webpack_public_path__ + "static/media/answer.4502a8d5.svg";